import { adminApi } from "./adminApi";
import { authApi } from "./authApi";
import backendUrl from "./backendUrl";
import { brandApi } from "./brandApi";
import { categoryApi } from "./categoryApi";
import { couponApi } from "./couponApi";
import { productApi } from "./productApi";
import { reviewApi } from "./reviewApi";
import { userApi } from "./userApi";
import { wishlistApi } from "./wishlistApi";

const SummaryApi = {
  ...authApi,
  ...productApi,
  ...userApi,
  ...categoryApi,
  ...brandApi,
  ...reviewApi,
  ...couponApi,
  ...adminApi,
  ...wishlistApi,
  myRefunds: {
    url: `${backendUrl}/api/my-refunds`,
    method: "get",
  },
  requestRefund: {
    url: `${backendUrl}/api/request-refund`,
    method: "post",
  },
};

export default SummaryApi;
